module.exports = __webpack_public_path__ + "img/logoWhite.d5449349.png";